import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import axios from 'axios';
import Popup from '../../../components/Popup';
import ConfirmAccountDelete from './ConfirmAccountDelete'
import EditAccount from './EditAccount'
import { useSetRecoilState, useRecoilValue } from 'recoil'
import { accountsState } from '../recoil/atoms'
import { filteredAccountsState } from '../recoil/selectors'

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
});


const Account = props => {
    const { account, number } = props;
    const classes = useRowStyles();
    const [deleteAccountPopup, setDeleteAccountPopup] = useState(false)
    const [editAccountPopup, setEditAccountPopup] = useState(false)
    return (
        <>
            <Popup
                title={"آیا از حذف حساب " + account.title + " مطمئن هستید؟"}
                openPopup={deleteAccountPopup}
                setOpenPopup={setDeleteAccountPopup}
            >
                <ConfirmAccountDelete id={account.id} setPopup={setDeleteAccountPopup} />
            </Popup>
            <Popup
                title='ویرایش'
                openPopup={editAccountPopup}
                setOpenPopup={setEditAccountPopup}
            >
                <EditAccount id={account.id} setPopup={setEditAccountPopup} />
            </Popup>
            <TableRow className={classes.root}>
                <TableCell component="th" scope="row">
                    {number}
                </TableCell>
                <TableCell component="th" scope="row">
                    {account.title}
                </TableCell>
                <TableCell component="th" scope="row">
                    {account.owner}
                </TableCell>
                <TableCell component="th" scope="row">
                    {account.number}
                </TableCell>
                <TableCell component="th" scope="row">
                    {account.bank_name}
                </TableCell>
                <TableCell component="th" scope="row">
                    {account.branch_name}
                </TableCell>
                <TableCell component="th" scope="row">
                    {account.cheque_setting_title === null ? 'تعیین نشده' : account.cheque_setting_title}
                </TableCell>
                <TableCell align="right">
                    <IconButton onClick={() => setEditAccountPopup(true)} size="small">
                        <EditIcon />
                    </IconButton>
                </TableCell>
                <TableCell align="right">
                    <IconButton onClick={() => setDeleteAccountPopup(true)} size="small">
                        <DeleteIcon />
                    </IconButton>
                </TableCell>
            </TableRow>
        </>
    );
}


const AccountsTable = () => {
    const filteredAccounts = useRecoilValue(filteredAccountsState)
    const setAccounts = useSetRecoilState(accountsState)
    const getAccountsData = async () => {
        const data = await axios.get('accounts/account/').then(result => result.data)
        setAccounts(data)
    }
    useEffect(() => {
        getAccountsData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <TableContainer component={Paper}>
            <Table aria-label="accounts">
                <TableHead>
                    <TableRow>
                        <TableCell>ردیف</TableCell>
                        <TableCell>عنوان حساب</TableCell>
                        <TableCell>صاحب حساب</TableCell>
                        <TableCell>شماره حساب</TableCell>
                        <TableCell>بانک</TableCell>
                        <TableCell>شعبه</TableCell>
                        <TableCell>نوع چک</TableCell>
                        <TableCell align="right">
                            ویرایش
                        </TableCell>
                        <TableCell align="right">
                            حذف
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {filteredAccounts.map((account, key) => (
                        <Account key={account.id} number={key + 1} account={account} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default AccountsTable